export default {
  buttons: {
    title1: 'Zuschneiden',
    title2: 'Schließen',
  },
};
